import { Component, Input, OnInit } from '@angular/core';
import { SensorDataService } from '../../../../core/device/services/sensor-data.service';
import * as _ from 'lodash';
import { yyyymmddhhmm } from '../../../../core/util/date.util';

@Component({
    selector: 'app-device-popover',
    templateUrl: 'device-popover.html',
    styleUrls: [
        './device-popover.scss'
    ]
})

export class DevicePopoverComponent implements OnInit {

    @Input() location;
    @Input() device;
    selectedDevice: any;
    sensorList: any[] = [];
    loading = true;
    loadError = false;

    constructor(
        private sensorDataService: SensorDataService
    ) { }

    ngOnInit() {
        const devices = this.location
            ? (Array.isArray(this.location.Devices)
                ? this.location.Devices
                : Array.isArray(this.location.devices) ? this.location.devices : [])
            : [];
        const selectedDevice = this.device && devices.find(item => Number(item.id) === Number(this.device.id));
        const device = selectedDevice || this.device || devices[0];
        if (device) {
            this.selectDevice(device);
        } else {
            this.loading = false;
            this.loadError = true;
        }
    }

    selectDevice(device: any) {
        if (!device) {
            this.loading = false;
            this.loadError = true;
            return;
        }

        this.selectedDevice = device;
        this.sensorList = [];
        this.loading = true;
        this.loadError = false;
        this.sensorDataService.instant({
            device_id: device.id
        }).subscribe((response: any) => {
            const data = response && Array.isArray(response.itemList) ? response.itemList : [];
            this.sensorList = data.map((row: any) => {
                const date = new Date(row.create_date);
                return {
                    name: _.get(row, 'SensorType.name', 'Desconocido'),
                    value: row.value,
                    ts: !isNaN(date.getTime()) ? yyyymmddhhmm(date) : 'Sin fecha',
                    sortDate: date.getTime()
                };
            }).sort((first, second) => second.sortDate - first.sortDate);
            this.loading = false;
        }, () => {
            this.loading = false;
            this.loadError = true;
        });
    }

    get deviceDescription(): string {
        return this.selectedDevice && (
            this.selectedDevice.description ||
            this.selectedDevice.name ||
            this.selectedDevice.internal_code
        ) || 'Gateway sin descripción';
    }

    get deviceTypeName(): string {
        const typeName = _.get(this.selectedDevice, 'DeviceType.name') ||
            _.get(this.location, 'LocationType.name') ||
            _.get(this.location, 'location_type.name');
        if (typeName) return typeName;

        switch (Number(this.location && this.location.location_type_id)) {
            case 5: return 'SIAC-GW';
            case 6: return 'SIAC-RELAY';
            default: return 'Dispositivo';
        }
    }

    get deviceIdentifier(): string {
        const identifier = this.selectedDevice && (
            this.selectedDevice.mac ||
            this.selectedDevice.internal_code ||
            this.selectedDevice.id
        );
        return identifier !== undefined && identifier !== null ? String(identifier) : 'Sin información';
    }

    get latestReading(): any {
        return this.sensorList && this.sensorList.length ? this.sensorList[0] : null;
    }

    close() {
        // El cierre lo controla el modal padre mediante su botón Aceptar/X.
    }
}
